import Cookies from "js-cookie";

const LOCAL_MODE_RAW = Cookies.get("InfoFringaleUser");
const LOCAL_MODE = LOCAL_MODE_RAW ? JSON.parse(LOCAL_MODE_RAW) : null;

const MODE = LOCAL_MODE?.mode;

export { MODE };
